import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import type { IFormElement } from '../types';
import styles from './fields.module.css';

export interface MultipleTextFieldProps {
  element: IFormElement;
  questionNumber?: number;
}

export const MultipleTextField: React.FC<MultipleTextFieldProps> = ({
  element,
  questionNumber,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = errors[element.name];

  const items = element.items || [];

  const renderLabel = () => {
    if (!element.title) return null;
    return (
      <label
        className={`${styles.label} ${
          element.isRequired ? styles.required : ''
        }`}
      >
        {questionNumber && (
          <span className={styles.questionNumber}>{questionNumber}. </span>
        )}
        {element.title}
      </label>
    );
  };

  return (
    <div className={styles.formField}>
      {renderLabel()}
      {element.description && (
        <p className={styles.description}>{element.description}</p>
      )}
      <Controller
        name={element.name}
        control={control}
        defaultValue={{}}
        render={({ field }) => {
          const values: Record<string, string> = field.value || {};

          const handleChange = (itemName: string, value: string) => {
            field.onChange({
              ...values,
              [itemName]: value,
            });
          };

          return (
            <div className={styles.multipleTextGroup}>
              {items.map((item: any, index: number) => {
                const itemName = typeof item === 'object' ? item.name : item;
                const itemTitle =
                  typeof item === 'object' ? item.title || item.name : item;
                const placeholder =
                  typeof item === 'object' ? item.placeHolder || '' : '';
                const inputType =
                  typeof item === 'object' ? item.inputType || 'text' : 'text';
                const isRequired =
                  typeof item === 'object' ? item.isRequired : false;
                const maxLength =
                  typeof item === 'object' ? item.maxLength : undefined;

                return (
                  <div key={index} className={styles.multipleTextItem}>
                    <label
                      className={`${styles.multipleTextLabel} ${
                        isRequired ? styles.required : ''
                      }`}
                    >
                      {itemTitle}
                    </label>
                    <input
                      type={inputType}
                      className={styles.input}
                      value={values[itemName] || ''}
                      onChange={(e) => handleChange(itemName, e.target.value)}
                      placeholder={placeholder}
                      maxLength={maxLength}
                      disabled={element.readOnly}
                    />
                  </div>
                );
              })}
            </div>
          );
        }}
      />
      {error && (
        <p className={styles.errorMessage}>{error.message as string}</p>
      )}
    </div>
  );
};

export default MultipleTextField;
